import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    row-gap: 10px;
    max-width: 370px;
    min-height: 120px;
    padding: 16px;
    border: 1px solid ${colors.dimGrey};
    background-color: ${colors.black2};

    .itemTitle {
      color: ${colors.white};
      font-size: 12px;
      font-weight: 400;
    }

    .createdAt, .amount, .cardNumber, .description, .voidedAt, .voidDescription {
      color: ${colors.white};
      font-size: 14px;
      font-weight: 600;
    }

    .status {
      color: ${colors.grey};
      font-size: 14px;
      font-weight: 600;
    }

    .originator, .voidOriginator {
      color: ${colors.green};
      font-size: 14px;
      font-weight: 400;
    }

    .highlight {
      color: ${colors.red};
    }

    .approval {
      color: ${colors.green};
    }
    .acknowledged {
      color: ${colors.lightBlue};
    }
`;
